import styled from "styled-components";
import { useState, useEffect } from "react";
import request from "../../../api/request";
import { NotificationManager, NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import NarrowGrid from "../../../components/NarrowGrid";
import FormDatePicker from "../../../components/FormControls/FormDatePicker";
import SecondaryButton from "../../../components/FormControls/SecondaryButton";

const GrayBackground = styled.div`
    font-family: ${(props) => props.theme.fonts.SegoeUI};
    background-color: ${(props) => props.theme.color.lightgray};
    padding: 45px;
    height: calc(100vh - 210px);
    overflow: auto;


`;

const StyledAuditLog = styled.div`
    margin-top: 20px;
    background-color: white;
    padding: 30px;
    box-sizing: border-box;
    width: 1000px;
    min-height: 536px;
`;

const PageTitle = styled.span`
    font-size: 20px;
    font-weight: 600;
    color: ${(props) => props.theme.color.dark};
`;

const Show1000Rows = styled.p`
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 0;
    color: ${(props) => props.theme.color.primaryblue};
`;

function AuditLog(props) {

    const [loadedPage, setLoadedPage] = useState(false);
    const [auditLogs, setAuditLogs] = useState([]);
    const [selectedAuditLog, setSelectedAuditLog] = useState(null);
    const [selectedAuditLogId, setSelectedAuditLogId] = useState(null);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Username', type: 'String', width: 135, textAlign: 'left'},
        {id: 'Timestamp', type: 'String', width: 150, textAlign: 'left'},
        {id: 'IP Address', type: 'String', width: 120, textAlign: 'center'},
        {id: 'Browser', type: 'String', width: 160, textAlign: 'left'},
        {id: 'OS', type: 'String', width: 80, textAlign: 'left'},
        {id: 'Login status', type: 'String', width: 170, textAlign: 'left'},
        {id: 'Login attempts', type: 'String', width: 105, textAlign: 'right'}
    ]);
    const [gridData, setGridData] = useState({groups: [''], items: [[]]});

    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [needsValidation, setNeedsValidation] = useState(false);
    const [isFiltering, setIsFiltering] = useState(false);

    const onSelectGridItem = (item) => {
        setSelectedAuditLogId(item.Id);
        setSelectedAuditLog(auditLogs[item.Id]);
    }

    const convertDateToUTCTimeZone = (val) => {
        let diffMinutes = val.getTimezoneOffset();
        val.setTime(val.getTime() - diffMinutes*60*1000);
        return val;
    }

    const dateToStr = (date) => {
        function pad(s) { return (s < 10) ? '0' + s : s; };
        function pad1(s) {
            if (s < 10) return '00' + s;
            else if (s < 100) return '0' + s;
            else return s;
        };
        let ret = [pad(date.getFullYear()), pad(date.getMonth()+1), date.getDate()].join('-') + " " + [pad(date.getHours()), pad(date.getMinutes()), pad(date.getSeconds())].join(':') + "." + pad1(date.getMilliseconds());
        return ret;
    }

    const loginStatusNumToStr = (num) => {
        if (num === 1) {
            return 'Logged in succesfully';
        } else if (num === 2) {
            return 'Logged out succesfully';
        } else if (num === 3) {
            return 'Incorrect username';
        } else if (num === 4) {
            return 'Incorrect password';
        } else if (num === 5) {
            return 'Locked out';
        } else {
            return 'Unknown';
        }
    }

    const fetchAuditLogs = async () => {
        try {
            let auditLogList = [];

            let resp = (await request('database', 'fetchAuditLogs'));
            if (resp.ok) {
                resp.data.map((auditLog, index) => {
                    auditLogList.push(auditLog);
                });
                setAuditLogs(auditLogList);
                rebuildGridData(auditLogList);
            } else {
                console.log('Failed fetchAuditLogs');
                NotificationManager.error(resp.data);
            }
        } catch (e) {
            console.log('Failed to fetch audit logs: ', e);
        }
    }

    const rebuildGridData = (auditLogList) => {
        if (auditLogList && auditLogList.length > 0) {
            let auditLogItems = [];
            auditLogList.map((auditLog, index) => {
                let isFiltered = true;
                let timeStamp = convertDateToUTCTimeZone(new Date(auditLog.Timestamp));
                if (fromDate && toDate) {
                    let from = new Date(fromDate);
                    from.setHours(0);
                    from.setMinutes(0);
                    from.setSeconds(0);
                    let to = new Date(toDate);
                    to.setHours(23);
                    to.setMinutes(59);
                    to.setSeconds(59);
                    if (timeStamp.getTime() < from.getTime() || timeStamp.getTime() > to.getTime()) {
                        isFiltered = false;
                    }
                }
                if (isFiltered) {
                    auditLogItems.push({Id: index, 
                        'Username': auditLog.UserName,
                        'Timestamp': dateToStr(timeStamp),
                        'IP Address': auditLog.IPAddress ? auditLog.IPAddress : '',
                        'Browser': auditLog.BrowserDetails ? auditLog.BrowserDetails : '',
                        'OS': auditLog.OSDetails ? auditLog.OSDetails : '',
                        'Login status': loginStatusNumToStr(auditLog.LoginStatus),
                        'Login attempts': auditLog.LoginAttempts.toString()});
                }
                setIsFiltering(false);
            });
            setGridData({groups: [''], items: [auditLogItems]});
        } else {
            setGridData({groups: [''], items: [[]]});
        }
    }

    const onClickFilter = () => {
        if (!fromDate || !toDate) {
            setNeedsValidation(true);
        } else {
            setNeedsValidation(false);
            setIsFiltering(true);
            rebuildGridData(auditLogs);
            setIsFiltering(false);
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            fetchAuditLogs();
            setLoadedPage(true);
            setNeedsValidation(false);
        }
    }, [selectedAuditLog]);

    return (
        <GrayBackground>
            <div style={{display:'block', margin:'auto', width:1000}}>
                <PageTitle>Audit Log</PageTitle>
                <StyledAuditLog>
                    <div style={{display: 'flex'}}>
                        <FormDatePicker label='From' value={fromDate} onChange={(val) => setFromDate(val)} validated={needsValidation && !fromDate ? false : undefined} style={{width:150, paddingTop:0}}></FormDatePicker>
                        <FormDatePicker label='To' value={toDate} onChange={(val) => setToDate(val)} validated={needsValidation && !toDate ? false : undefined} style={{width:150, marginLeft:30, paddingTop:0}}></FormDatePicker>
                        <SecondaryButton caption='Filter search' onClick={() => onClickFilter()} style={{width:150, marginLeft:30, marginTop:'auto'}}></SecondaryButton>
                    </div>
                    <NarrowGrid id='auditlog_grid' gridColumns={gridColumns} gridData={gridData} itemIdToSelect={selectedAuditLogId} onSelectGridItem={onSelectGridItem} gridStyle={{width:920, height:400, marginTop: 20}}></NarrowGrid>
                    
                    <Show1000Rows>{'(* Show 5000 rows maximum)'}</Show1000Rows>
                </StyledAuditLog>
            </div>
            <NotificationContainer/>
        </GrayBackground>
    )
}

export default AuditLog;